import * as angular from "angular";
import * as _ from "lodash";
import {AccountModel} from "../angular/models/account.model";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class AccountsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  demandGetManyError() {
    const message = {
      body: 'DEMAND_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandCreateSuccess() {
    const message = {
      body: 'DEMAND_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandCreateError(error) {
    const message = {
      body: 'DEMAND_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  demandCreateManyError(error) {
    const message = {
      body: 'DEMAND_CREATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  demandUpdateSuccess() {
    const message = {
      body: 'DEMAND_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandUpdateError() {
    const message = {
      body: 'DEMAND_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandRemoveSuccess(account: AccountModel) {
    const message = {
      body: 'X_DEMAND_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message, account)
  }

  demandRemoveError() {
    const message = {
      body: 'DEMAND_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandDeleteOneSuccess(account?: AccountModel) {
    const message = {
      body: 'X_DEMAND_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, account)
  }

  demandDeleteOneError() {
    const message = {
      body: 'DEMAND_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandAddToBranchSuccess() {
    const message = {
      body: 'DEMAND_ADD_TO_BRANCH_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandAddToBranchError() {
    const message = {
      body: 'DEMAND_ADD_TO_BRANCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  supplyAddToBranchSuccess() {
    const message = {
      body: 'SUPPLY_ADD_TO_BRANCH_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  supplyAddToBranchError() {
    const message = {
      body: 'SUPPLY_ADD_TO_BRANCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandRemoveFromBranchSuccess(account: AccountModel) {
    const message = {
      body: 'X_DEMAND_REMOVE_FROM_BRANCH_SUCCESS'
    };
    return this.bringozToastService.success(message, account)
  }

  demandRemoveFromBranchError() {
    const message = {
      body: 'DEMAND_REMOVE_FROM_BRANCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  supplyRemoveFromBranchSuccess(account: AccountModel) {
    const message = {
      body: 'X_SUPPLY_REMOVE_FROM_BRANCH_SUCCESS'
    };
    return this.bringozToastService.success(message, account)
  }

  supplyRemoveFromBranchError() {
    const message = {
      body: 'SUPPLY_REMOVE_FROM_BRANCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  demandAddToDepotSuccess() {
    const message = {
      body: 'DEMAND_ADD_TO_DEPOT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandAddToDepotError() {
    const message = {
      body: 'DEMAND_ADD_TO_DEPOT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_EXTERNAL_PROVIDER
  demandAddExternalProviderSuccess(providerName?) {
    const message = {
      body: 'DEMAND_ADD_EXTERNAL_PROVIDER_SUCCESS'
    };
    return this.bringozToastService.success(message, {providerName: providerName})
  }

  demandAddExternalProviderError() {
    const message = {
      body: 'DEMAND_ADD_EXTERNAL_PROVIDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandRemoveFromDepotSuccess(depot) {
    const message = {
      body: 'X_DEMAND_REMOVE_FROM_DEPOT_SUCCESS'
    };
    return this.bringozToastService.success(message, depot)
  }

  demandRemoveFromDepotError() {
    const message = {
      body: 'DEMAND_REMOVE_FROM_DEPOT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandAddPaymentSuccess() {
    const message = {
      body: 'DEMAND_ADD_PAYMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandAddPaymentError() {
    const message = {
      body: 'DEMAND_ADD_PAYMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandChangeDefaultPaymentSuccess() {
    const message = {
      body: 'DEMAND_CHANGE_DEFAULT_PAYMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandChangeDefaultPaymentError() {
    const message = {
      body: 'DEMAND_CHANGE_DEFAULT_PAYMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  demandRemovePaymentSuccess() {
    const message = {
      body: 'DEMAND_REMOVE_PAYMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  demandRemovePaymentError() {
    const message = {
      body: 'DEMAND_REMOVE_PAYMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  saveFavouriteSuccess() {
    const message = {
      body: 'DEMAND_SAVE_FAVOURITE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'DEMAND_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'DEMAND_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  supplyCreateSuccess() {
    const message = {
      body: 'SUPPLY_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  supplyCreateError() {
    const message = {
      body: 'SUPPLY_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  supplyUpdateSuccess() {
    const message = {
      body: 'SUPPLY_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  supplyUpdateError() {
    const message = {
      body: 'SUPPLY_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  supplyDeleteOneSuccess(account: AccountModel) {
    const message = {
      body: 'X_SUPPLY_DELETE_ONE_SUCCESS'
    };
    return this.bringozToastService.success(message, account)
  }

  supplyDeleteOneError(account?: AccountModel) {
    const message = {
      body: 'SUPPLY_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, account)
  }

  // UPLOAD //
  uploadError() {
    const message = {
      body: 'DEMAND_UPLOAD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  importAgentAssignmentsSuccess() {
    const message = {
      body: 'IMPORT_ENTITIES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  importAgentAssignmentsError(error?) {
    const message = {
      body: 'IMPORT_ENTITIES_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  contractRemovedSuccess() {
    const message = {
      body: 'CONTRACT_REMOVED_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  contractRemovedError() {
    const message = {
      body: 'CONTRACT_REMOVED_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  changeArchiveStatusSuccess() {
    const message = {
      body: 'DEMAND_UPDATE_ARCHIVE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  changeArchiveStatusError() {
    const message = {
      body: 'DEMAND_UPDATE_ARCHIVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateAccountSchedulingProjectConfigurationsSuccess() {
    const message = {
      body: 'UPDATE_ACCOUNT_SCHEDULING_PROJECT_CONFIGURATIONS_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateAccountSchedulingProjectConfigurationsError() {
    const message = {
      body: 'UPDATE_ACCOUNT_SCHEDULING_PROJECT_CONFIGURATIONS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  addPreferredAgentSuccess() {
    const message = {
      body: 'ADD_PREFERRED_AGENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }


  addPreferredAgentError() {
    const message = {
      body: 'ADD_PREFERRED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updatePreferredAgentSuccess() {
    const message = {
      body: 'UPDATE_PREFERRED_AGENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  updatePreferredAgentError() {
    const message = {
      body: 'UPDATE_PREFERRED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  removePreferredAgentSuccess() {
    const message = {
      body: 'REMOVE_PREFERRED_AGENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  removePreferredAgentError() {
    const message = {
      body: 'REMOVE_PREFERRED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  addRestrictedAgentSuccess() {
    const message = {
      body: 'ADD_RESTRICTED_AGENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }


  addRestrictedAgentError() {
    const message = {
      body: 'ADD_RESTRICTED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getRestrictedAgentsError() {
    const message = {
      body: 'GET_RESTRICTED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateRestrictedAgentSuccess() {
    const message = {
      body: 'UPDATE_RESTRICTED_AGENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateRestrictedAgentError() {
    const message = {
      body: 'UPDATE_RESTRICTED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  removeRestrictedAgentSuccess() {
    const message = {
      body: 'REMOVE_RESTRICTED_AGENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  removeRestrictedAgentError() {
    const message = {
      body: 'REMOVE_RESTRICTED_AGENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getAccountsWithPreferredAgentsError() {
    const message = {
      body: 'GET_ACCOUNTS_WITH_PREFERRED_AGENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  assignMultiplePreferredAgentsSuccess() {
    const message = {
      body: 'ASSIGN_MULTIPLE_PREFERRED_AGENTS_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  assignMultiplePreferredAgentsError() {
    const message = {
      body: 'ASSIGN_MULTIPLE_PREFERRED_AGENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.accounts')
  .service('accountsAlerts', AccountsAlerts);
